module.exports = __webpack_public_path__ + "static/media/main-smiles.673a6609.jpg";